import { ca } from '@cian/analytics';

import { IOffer } from 'shared/offer';

export const trackDeveloperCardLinkClick = (offer: IOffer) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'to_card_builder',
    label: 'description',
    products: [
      {
        id: offer.geo?.jk?.id || 0,
        offerType: 'JK',
      },
    ],
  });
};

export const trackAgentCardLinkClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'to_agency',
    label: 'card_detail',
    useLastProducts: true,
  });
};
